import {getDicts} from '@/api/system/dict/data';

import '@/assets/styles/index.scss'; // global css
import '@/assets/styles/ruoyi.scss'; // ruoyi css
import Pagination from '@/components/Pagination/index.vue';
// 自定义表格工具扩展
import RightToolbar from '@/components/RightToolbar/index.vue';
// plugins
import '@/plugins/index';
import {addDateRange, handleTree, parseTime, resetForm, selectDictLabel, selectDictLabels} from '@/utils/ruoyi';
import 'font-awesome/css/font-awesome.min.css';
import Vue from 'vue';
import App from './App.vue';
import './assets/icons'; // icon
import permission from './directive/permission';
import './permission'; // permission control
import router from './router';
import store from './store';
import axios from 'axios'

// @ts-ignore

// 全局方法挂载
Vue.prototype.getDicts = getDicts;
Vue.prototype.parseTime = parseTime;
Vue.prototype.resetForm = resetForm;
Vue.prototype.addDateRange = addDateRange;
Vue.prototype.selectDictLabel = selectDictLabel;
Vue.prototype.selectDictLabels = selectDictLabels;
Vue.prototype.handleTree = handleTree;


// 全局组件挂载
Vue.component('Pagination', Pagination);
Vue.component('RightToolbar', RightToolbar);

Vue.use(permission);

/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online! ! !
 */

Vue.config.productionTip = false;

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
});
// if (process.env.NODE_ENV === 'production') {
//     axios.defaults.baseURL = 'http://39.98.247.131/api'
// }
